import { getCityCourtsPageUrlWithSport } from 'constants/pages';
import SectionDivider from 'screens/ClubOverview/components/SectionDivider';
import { ButtonLink } from 'components/Button';
import CardVenue from 'components/cards/CardVenue';
import { CourtPageVenue } from '../../types';
import { getPrimarySport, getPrimarySportEnum } from '../../utils';

const MAX_CARDS = 4;

interface Props {
  venue: CourtPageVenue;
}

export default function NearbyCourts({ venue }: Props) {
  const city = venue.city;
  const nearbyVenues = (city?.venues || [])
    .filter((cityVenue) => !!cityVenue?.id && cityVenue.id !== venue.id)
    .slice(0, MAX_CARDS);

  if (!city || nearbyVenues.length === 0) {
    return null;
  }

  // Nearby venues carry no sport flags, so default artwork follows this page's sport.
  const pageSport = getPrimarySportEnum(venue);

  return (
    <>
      <SectionDivider className="my-ds-3xl" />
      <section className="flex flex-col gap-ds-xl">
        <h2 className="typography-product-heading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          Explore courts near you
        </h2>
        {/* homePage = the design-system "Location card" variant: 16px semibold
            title + single-line truncated address (default is 20px bold, wrapping). */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {nearbyVenues.map((cityVenue) => (
            <CardVenue
              key={cityVenue.id}
              {...cityVenue}
              totalCourtCount={cityVenue.indoorCourtCount + cityVenue.outdoorCourtCount}
              imageUrl={cityVenue.images[0]?.url}
              primarySport={pageSport}
              impressionSource="CLUB_PAGE"
              homePage
            />
          ))}
        </div>
        <div className="flex">
          <ButtonLink
            href={getCityCourtsPageUrlWithSport(city.slug || '', getPrimarySport(venue))}
            variant="secondary"
            size="md"
            isInline
          >
            View all courts
          </ButtonLink>
        </div>
      </section>
    </>
  );
}
